<template>
    <div class=" pt-5 px-5">
        <button class="text-white w-full rounded-40 pt-5 pb-4 font-SemiBold" :style="backgroundStyle" @click="clickButton()">
            {{lbl.paywithpoint.create_btn}}
        </button>
    </div>
</template>
<script>
export default {
    name: 'OrangeButton',
    props: {
        lbl: Object,
        blobConfig: { type: Object }
    },
    data: function() {
        return {
            backgroundStyle: {
                backgroundColor : '',
            },
        }
    },
    created: function() {
        this.setupTheme();
    },
    methods: {
        setupTheme: function() {
            this.backgroundStyle.backgroundColor = this.blobConfig.appConfig.blobConfig.btn_color
        },
        clickButton: function() {
            this.$emit('clickButton')
        }
    }
}
</script>
<style lang="scss" scoped>
@import '../../style/base.scss';
.font-SemiBold {
    font-family: $ff-semi;
}
</style>
